import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import Api from "../../admin/components/api/Api";
import Notification, { showToast } from "../../components/common/notification/Notification";
import LocationSelector from "../../components/customer/LocationSelector";
import "./ProfileForm.css";

const ProfileForm = () => {
  const [services, setServices] = useState([]);
  const [locationValue, setLocationValue] = useState({
    country: "",
    state: "",
    city: "",
    area: "",
  });
  const navigate = useNavigate();

  const loggedInUser = useSelector((state) => state.auth.user);
  const userId = loggedInUser?.user?.id;
  const userType = loggedInUser?.user?.userType?.name;
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [profile, setProfile] = useState({ id: userId });

  const editDetailsApi = Api({ url: `admin/editUser` });

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(`${baseUrl}/all/services`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setServices(response.data.services || []);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };

    fetchServices();
  }, [baseUrl, token]);

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;

    setProfile((currentProfile) => ({
      ...currentProfile,
      [name]: value,
    }));
  };

  const handleLocationChange = (updatedValue) => {
    setLocationValue(updatedValue);
    setProfile((currentProfile) => ({
      ...currentProfile,
      country_id: updatedValue.country || "",
      state_id: updatedValue.state || "",
      city_id: updatedValue.city || "",
      area_id: updatedValue.area || "",
    }));
  };

  const handleServiceChange = (event) => {
    setProfile((currentProfile) => ({
      ...currentProfile,
      service_id: event.target.value,
    }));
  };

  const handleSkipClick = () => {
    navigate("/customer/workspace", { replace: true });
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    try {
      const responseData = await editDetailsApi.editData(profile);
      if (responseData.data.statusType === "SUCCESS") {
        showToast("Profile updated successfully", { type: "success" });
        navigate("/customer/workspace", { replace: true });
      }
    } catch {
      showToast("Something went wrong", { type: "error" });
    }
  };

  return (
    <div className="pf">
      <Notification />

      <div className="pf__card">
        <h2 className="pf__title">Complete Your Profile</h2>
        <p className="pf__subtitle">Add your details or skip to continue</p>

        <form onSubmit={handleProfileSubmit} className="pf__form">

          <div className="pf__row">
            <div>
              <label className="pf__field-label">First Name</label>
              <input
                className="pf__input"
                type="text"
                name="first_name"
                placeholder="Enter first name"
                value={profile.first_name || ""}
                onChange={handleTextInputChange}
              />
            </div>
            <div>
              <label className="pf__field-label">Last Name</label>
              <input
                className="pf__input"
                type="text"
                name="last_name"
                placeholder="Enter last name"
                value={profile.last_name || ""}
                onChange={handleTextInputChange}
              />
            </div>
          </div>

          <div>
            <label className="pf__field-label">Email</label>
            <input
              className="pf__input"
              type="email"
              name="email_address"
              placeholder="Enter email"
              value={profile.email_address || ""}
              onChange={handleTextInputChange}
            />
          </div>

          <div>
            <LocationSelector
              value={locationValue}
              onChange={handleLocationChange}
              levels={["state", "city"]}
            />
          </div>

          {userType === "PARTNER" && (
            <div>
              <label className="pf__field-label">Service</label>
              <select
                className="pf__select"
                value={profile.service_id || ""}
                onChange={handleServiceChange}
              >
                <option value="">Select service</option>
                {services.map((service) => (
                  <option key={service.id} value={service.id}>{service.name}</option>
                ))}
              </select>
            </div>
          )}

          <div className="pf__actions">
            <button
              type="button"
              className="pf__btn-skip"
              onClick={handleSkipClick}
            >
              Skip for now
            </button>
            <button type="submit" className="pf__btn-save">
              Save & Continue
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default ProfileForm;
